
<p-card>
    <p-table [value]="tpreplist" [tableStyle]="{'min-width': '50rem'}" #dt
        [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
        [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [globalFilterFields]="['instrument','pLVPlate']" [columns]="cols"
        stateStorage="local" stateKey="tpreplist-state">
        <ng-template pTemplate="caption">
            <div class="flex">
                <button pButton type="button" label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt)"></button>
                <button type="button" pButton icon="pi pi-file" iconPos="left" label="Export" (click)="dt.exportCSV()" style="margin-left: 0.5em;"></button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="applyFilterGlobal($event, 'contains')" placeholder="Search keyword" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr> 
                <th pSortableColumn="instrument" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Instrument
                        <p-sortIcon field="instrument"></p-sortIcon>
                        <p-columnFilter type="text" field="instrument" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="plvPlate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        PLV Plate
                        <p-sortIcon field="plvPlate"></p-sortIcon>
                        <p-columnFilter type="text" field="plvPlate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="tip" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Tip
                        <p-sortIcon field="tip"></p-sortIcon>
                        <p-columnFilter type="text" field="tip" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="startDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Start Date
                        <p-sortIcon field="startDate"></p-sortIcon>
                        <p-columnFilter type="date" field="startDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="tPrepIncident" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        TPrep Incident
                        <p-sortIcon field="tPrepIncident"></p-sortIcon>
                        <p-columnFilter type="text" field="tPrepIncident" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="tPrepIncidentDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        TPrep Incident Date
                        <p-sortIcon field="tPrepIncidentDate"></p-sortIcon>
                        <p-columnFilter type="date" field="tPrepIncidentDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="tPrepService" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        TPrep Service
                        <p-sortIcon field="tPrepService"></p-sortIcon>
                        <p-columnFilter type="text" field="tPrepService" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="tPrepServiceDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        TPrep Service Date
                        <p-sortIcon field="tPrepServiceDate"></p-sortIcon>
                        <p-columnFilter type="date" field="tPrepServiceDate" display="menu"></p-columnFilter>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tprep>
            <tr (click)="rowClick(tprep)">
                <td>{{tprep.instrument}}</td>
                <td>{{tprep.plvPlate}}</td>
                <td>{{tprep.tip}}</td>
                <td>{{tprep.startDate | date:'short'}}</td>
                <td>{{tprep.tPrepIncident}}</td>
                <td>{{tprep.tPrepIncidentDate | date:'short'}}</td>
                <td>{{tprep.tPrepService}}</td>
                <td>{{tprep.tPrepServiceDate | date:'short'}}</td>
            </tr>
        </ng-template>
    </p-table>
</p-card>